import { ThemeProvider } from "@mui/material/styles";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import store from "./redux/store";
import { AppRouter } from "./routers/AppRouter";
import theme from "./theme/index";

function App() {
  useEffect(() => {
    if (
      window.location.href === "https://universoarcor.com/" ||
      window.location.href === "https://universoarcor.com.ar/"
    ) {
      ReactGA.send({
        hitType: "pageview",
        page: window.location.pathname + window.location.search,
        title: "Init",
      });
    }
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <AppRouter />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
